const Report = () =>
  import(
    /* webpackChunkName: "log-operation-anonymous" */ '@/pages/log/operation-anonymous/index.vue'
  )

const Detail = () =>
  import(
    /* webpackChunkName: "log-operation-anonymous" */ '@/pages/log/operation-anonymous/detail.vue'
  )

export default {
  path: 'operation-anonymous',
  meta: { label: 'operationAnonymous' },
  component: {
    name: 'OperationAnonymousLog',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LogOperationAnonymousReport',
      path: '',
      meta: { label: 'report' },
      component: Report
    },
    {
      name: 'LogDetailOperationAnonymous',
      path: 'detail/:id',
      meta: { label: 'detail' },
      component: Detail,
      props: true
    }
  ]
}
